import React from 'react';
import { Checkbox } from 'semantic-ui-react';

const CheckboxComponent = (props) => <Checkbox {...props} />;

export default CheckboxComponent;
